export default __webpack_public_path__ + "static/media/Icon_List.6352d652.svg";